import { useEffect } from "react";
import { getAuthHookFactory } from "../../../../../global/paywall/useAuth";
import { AuthStepsEnum, PremiumPaywallSignModes } from "../../../../../global/paywall/paywallInterfaces";
import { PremiumCalcalistPaywallDesktopSignupPassword } from "./signup/premiumCalcalistPaywallDesktopSignupPassword";
import { PremiumCalcalistPaywallDesktopSignupConfirmTerms } from "./signup/premiumCalcalistPaywallDesktopSignupConfirmTerms"
import { PremiumCalcalistPaywallDesktopSignupEmail } from "./signup/premiumCalcalistPaywallDesktopSignupEmail";
import { LegalLink } from "../mobile/premiumCalcalistPaywallMobile"


interface PremiumCalcalistPaywallDesktopSignupProps {
  email: string
  password: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  setIsRedirecting: (isRedirect: boolean) => void
  legalLinks: { terms: LegalLink; privacy: LegalLink };
}

export const PremiumCalcalistPaywallDesktopSignup = (props: PremiumCalcalistPaywallDesktopSignupProps) => {

  const { email, setEmail, password, setPassword, setMode, agreesTerms, setAgreesTerms, setIsRedirecting, legalLinks } = props

  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    resetAuth,
  } = getAuthHookFactory("signup")();


    useEffect(() => {
      if (/^\d+$/.test(email)) {
        setEmail('');
      }
    }, []);
    

  const sendMail = () => {
    sendEmailOrPhoneForLogin(email, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
    setAgreesTerms(false)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  switch (step) {
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumCalcalistPaywallDesktopSignupEmail
          email={email}
          agreesTerms={agreesTerms}
          setEmail={setEmail}
          setAgreesTerms={setAgreesTerms}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          legalLinks={legalLinks}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumCalcalistPaywallDesktopSignupPassword
          email={email}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
        />
      )

    case AuthStepsEnum.CONFIRM_TERMS:
      return (
        <PremiumCalcalistPaywallDesktopSignupConfirmTerms
          resetAuth={onReset}
          legalLinks={legalLinks}
          thirdPartyLogin={onThirdPartyLogin}

        />
      )

    case AuthStepsEnum.FINISH:
      // setTimeout(() => { window.location.reload() }, 2000)
      setIsRedirecting(true)
      return null;

    default:
      return null
  }
};
